export default __webpack_public_path__ + "744fe6d80266616aba687006b7d764ad.jpg";